import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionWrapper } from './SectionWrapper';
export function GuaranteeSection() {
  return <section className="py-20 md:py-28 bg-[#1A2E1E]" data-id="element-176">
      <div className="container mx-auto px-4" data-id="element-177">
        <div className="max-w-3xl mx-auto" data-id="element-178">
          <SectionWrapper data-id="element-179">
            <div className="text-center relative" data-id="element-180">
              <div className="flex justify-center mb-8" data-id="element-181">
                <div className="w-24 h-24 rounded-full bg-gold/10 flex items-center justify-center border border-gold/20 shadow-[0_0_30px_rgba(201,168,76,0.15)]" data-id="element-182">
                  <ShieldCheckIcon className="w-12 h-12 text-gold" data-id="element-183" />
                </div>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-white mb-8 leading-tight" data-id="element-184">
                Garantía de <span className="text-gold" data-id="element-185">7 Días</span>
                <br data-id="element-186" />
                Sin Preguntas
              </h2>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12" data-id="element-187">
                <p className="text-white/90 font-poppins text-lg md:text-xl leading-relaxed mb-6 font-medium" data-id="element-188">
                  Estamos tan seguros de que este sistema te va a dar
                  resultados, que asumimos todo el riesgo. Comprá el MegaKit
                  hoy. Leelo. Aplicá el protocolo del Tomo 3 en el próximo
                  berrinche.
                </p>

                <p className="text-white/80 font-poppins text-base md:text-lg leading-relaxed mb-8" data-id="element-189">
                  Si sentís que no te sirve, que no es para vos, o simplemente
                  no te gusta cómo está escrito, nos mandás un email antes de
                  los 7 días y te hacemos un{' '}
                  <strong className="text-gold font-bold" data-id="element-190">
                    100% de reembolso
                  </strong>
                  . Sin letras chicas. Sin tener que dar explicaciones.
                </p>

                <div className="inline-block px-8 py-3 rounded-full bg-gold/20 border border-gold/30" data-id="element-191">
                  <span className="text-gold font-poppins font-bold tracking-wide" data-id="element-192">
                    Tu tranquilidad está 100% garantizada.
                  </span>
                </div>
              </div>
            </div>
          </SectionWrapper>
        </div>
      </div>
    </section>;
}